import { makeStyles } from "@material-ui/core/styles";
import {
  LightPrimaryColor,
  PrimaryColor,
  White,
} from "../../shared/styles/colors";

export default makeStyles(() => ({
  estimateContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
    background: "rgba(214, 214, 214, .3)",
    "@media (max-width: 640px)": {
      flexDirection: "column",
      padding: "20px",
      height: "auto",
    },
  },
  estimateTotalCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "650px !important",
    height: "500px",
    padding: "50px",
    borderRadius: "5px",
    backgroundColor: "#ffffff", // White background for the card
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
    "@media (max-width: 640px)": {
      width: "100% !important",
      height: "auto",
      padding: "20px",
      justifyContent: "center",
    },
  },
  logo: {
    width: 150,
    height: 50,
    marginBottom: "2rem",
  },
  totalText: {
    fontSize: 14,
    textTransform: "uppercase",
    color: "#858585",
  },
  totalValue: {
    color: "black",
    fontSize: 35,
    fontWeight: 700,
    wordWrap: "break-word",
  },
  acceptButton: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "100% !important",
    color: White,
    background: PrimaryColor,
    borderRadius: "5px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
  },
  declineButton: {
    padding: "0.5rem",
    margin: "0.5rem",
    width: "100% !important",
    color: PrimaryColor,
    background: White,
    borderRadius: "5px",
    border: "1px solid #1e2e55",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
      color: White,
    },
  },
  infoText: {
    color: "#858585",
    fontSize: 12,
  },
  detailContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "350px !important",
    height: "500px",
    marginLeft: "20px",
    "@media (max-width: 640px)": {
      width: "100% !important",
      height: "auto",
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  estimateDetailCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    width: "100% !important",
    height: "48%",
    padding: "32px",
    borderRadius: "5px",
    backgroundColor: "#ffffff", // White background for the card
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
     "@media (max-width: 640px)": {
      width: "100% !important",
      height: "auto",
      marginTop: "20px",
      marginLeft: "0px",
    },
  },
  brandText: {
    fontSize: 20,
    fontWeight: 700,
  },
  greyText: {
    color: "#858585",
    textDecoration: "none",
    textTransform: "none",
  },
  boldText: {
    fontWeight: "bold",
  },
  downloadInfoDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
    marginLeft: 20,
  },
  buttonDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100% !important",
  },
  noEstimateContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100vh",
  },
  backButton: {
    padding: "0.5rem",
    margin: "0.5rem",
    color: White,
    background: PrimaryColor,
    borderRadius: "5px",
    textTransform: "none",
    "&:hover": {
      background: LightPrimaryColor,
    },
  },
}));
